export const enum eventAlbumSelectionConstants {
  fetchWorkspaceRequest = "EVENT_ALBUM_SELECTION_FETCH_WORKSPACE_REQUEST",
  fetchWorkspaceSuccess = "EVENT_ALBUM_SELECTION_FETCH_WORKSPACE_SUCCESS",
  fetchWorkspaceFailure = "EVENT_ALBUM_SELECTION_FETCH_WORKSPACE_FAILURE",

  fetchSummaryRequest = "EVENT_ALBUM_SELECTION_FETCH_SUMMARY_REQUEST",
  fetchSummarySuccess = "EVENT_ALBUM_SELECTION_FETCH_SUMMARY_SUCCESS",
  fetchSummaryFailure = "EVENT_ALBUM_SELECTION_FETCH_SUMMARY_FAILURE",

  changeStatusRequest = "EVENT_ALBUM_SELECTION_CHANGE_STATUS_REQUEST",
  changeStatusSuccess = "EVENT_ALBUM_SELECTION_CHANGE_STATUS_SUCCESS",
  changeStatusFailure = "EVENT_ALBUM_SELECTION_CHANGE_STATUS_FAILURE",

  listCuratedRequest = "EVENT_ALBUM_SELECTION_LIST_CURATED_REQUEST",
  listCuratedSuccess = "EVENT_ALBUM_SELECTION_LIST_CURATED_SUCCESS",
  listCuratedFailure = "EVENT_ALBUM_SELECTION_LIST_CURATED_FAILURE",
  listCuratedMore = "EVENT_ALBUM_SELECTION_LIST_CURATED_MORE",
  listCuratedMoreSuccess = "EVENT_ALBUM_SELECTION_LIST_CURATED_MORE_SUCCESS",

  addRemainingRequest = "EVENT_ALBUM_SELECTION_ADD_REMAINING_REQUEST",
  addRemainingSuccess = "EVENT_ALBUM_SELECTION_ADD_REMAINING_SUCCESS",
  addRemainingFailure = "EVENT_ALBUM_SELECTION_ADD_REMAINING_FAILURE",

  customerValidateRequest = "EVENT_ALBUM_CUSTOMER_VALIDATE_REQUEST",
  customerValidateSuccess = "EVENT_ALBUM_CUSTOMER_VALIDATE_SUCCESS",
  customerValidateFailure = "EVENT_ALBUM_CUSTOMER_VALIDATE_FAILURE",

  customerSubmitRequest = "EVENT_ALBUM_CUSTOMER_SUBMIT_REQUEST",
  customerSubmitSuccess = "EVENT_ALBUM_CUSTOMER_SUBMIT_SUCCESS",
  customerSubmitFailure = "EVENT_ALBUM_CUSTOMER_SUBMIT_FAILURE",

  setActiveService = "EVENT_ALBUM_SELECTION_SET_ACTIVE_SERVICE",
  setActiveDeliverable = "EVENT_ALBUM_SELECTION_SET_ACTIVE_DELIVERABLE",
  updateLocalSelections = "EVENT_ALBUM_SELECTION_UPDATE_LOCAL_SELECTIONS",
  reset = "EVENT_ALBUM_SELECTION_RESET",
  resetCustomer = "EVENT_ALBUM_SELECTION_RESET_CUSTOMER",
  restoreCustomerSession = "EVENT_ALBUM_SELECTION_RESTORE_CUSTOMER_SESSION",

  addToSelectedRequest = "EVENT_ALBUM_ADD_TO_SELECTED_REQUEST",
  addToSelectedSuccess = "EVENT_ALBUM_ADD_TO_SELECTED_SUCCESS",
  addToSelectedFailure = "EVENT_ALBUM_ADD_TO_SELECTED_FAILURE",

  addToBackgroundRequest = "EVENT_ALBUM_ADD_TO_BACKGROUND_REQUEST",
  addToBackgroundSuccess = "EVENT_ALBUM_ADD_TO_BACKGROUND_SUCCESS",
  addToBackgroundFailure = "EVENT_ALBUM_ADD_TO_BACKGROUND_FAILURE",

  listSelectedRequest = "EVENT_ALBUM_LIST_SELECTED_REQUEST",
  listSelectedSuccess = "EVENT_ALBUM_LIST_SELECTED_SUCCESS",
  listSelectedFailure = "EVENT_ALBUM_LIST_SELECTED_FAILURE",
}
